

// vat-utils.js

const _vatLog = window.createLogger("VatUtils");

function getVatRate(countryCode) {
  try {
    const vatData = window.globalVatData;
    if (!vatData || !countryCode) return 0;
    const country = countryCode.toUpperCase();
    const vatInfo = vatData[country];
    if (!vatInfo || typeof vatInfo.vat === "undefined") return 0;

    const vatDecimal = Number(vatInfo.vat) / 100;
    return vatDecimal;
  } catch (err) {
    _vatLog.warn("getVatRate(): error →", err);
    return 0;
  }
}

function getPriceWithVat(basePrice, countryCode) {
  const vatRate = getVatRate(countryCode);
  return Number(basePrice) * (1 + vatRate);
}

function getPriceWithoutVat(vatInclusivePrice, countryCode) {
  const vatRate = getVatRate(countryCode);
  return Number(vatInclusivePrice) / (1 + vatRate);
}

function getVatAmount(vatInclusivePrice, countryCode) {
  const priceExcl = getPriceWithoutVat(vatInclusivePrice, countryCode);
  return Number(vatInclusivePrice) - priceExcl;
}
function getCustomerCountryCode() {
  const code = window.getSelectedMarketCountry();
  return code;
}
window.getVatRate = getVatRate;
window.getPriceWithVat = getPriceWithVat;
window.getPriceWithoutVat = getPriceWithoutVat;
window.getVatAmount = getVatAmount;
window.getCustomerCountryCode = getCustomerCountryCode;
